<!--  -->
<template>
  <div>
    <div class="layout">
      <div class="custom-wrap">
        <el-table :data="list"  style="width: 100%" empty-text="暂无数据"
         v-loading="loading"
        >
          <el-table-column prop="companyName" label="公司名称"> </el-table-column>
          <el-table-column prop="boothCode" label="展位号"> </el-table-column>
          <el-table-column prop="firstName" label="姓名"> </el-table-column>
          <el-table-column prop="idCard" label="身份证号"> </el-table-column>
          <el-table-column prop="tel" label="电话"> </el-table-column>
          <el-table-column prop="email" label="邮箱"> </el-table-column>
          <el-table-column prop="jobTitle" label="职务"> </el-table-column>
          <el-table-column prop="country" label="国家"> </el-table-column>
          <el-table-column prop="province" label="省份"> </el-table-column>
          <el-table-column prop="city" label="城市"> </el-table-column>
          <el-table-column prop="isPlant" label="是否同步">
            <template slot-scope="scope">
              <div>
                {{ scope.row.isPlant == true ? "是" : "否" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
               <Poptip
                confirm
                title="确认是否删除?"
                @on-ok="delItem(scope.row)"
                :transfer="true"
              >
                <span style="color: #f00; cursor: pointer">删除</span>
              </Poptip>
            </template>
          </el-table-column>
        </el-table>
        
        <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="margin: 20px; text-align: center"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
        <!-- <div class="u-empty" v-else>暂无数据</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QRCode from "qrcodejs2";
export default {
  props: {
    searchName: {
      type: String,
      default: "",
    },
    isPlant: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      columns1: [
        {
          title: "公司名称",
          key: "companyName",
          align: "center",
        },
        {
          title: "展位号",
          key: "boothCode",
          align: "center",
        },
        {
          title: "姓名",
          key: "firstName",
          align: "center",
        },
        {
          title: "身份证号",
          key: "idCard",
          align: "center",
        },
        {
          title: "电话",
          key: "tel",
          align: "center",
        },
        {
          title: "邮箱",
          key: "email",
          align: "center",
        },
        {
          title: "职务",
          key: "jobTitle",
          align: "center",
        },
        {
          title: "国家",
          key: "country",
          align: "center",
        },
        {
          title: "省份",
          key: "province",
          align: "center",
        },
        {
          title: "城市",
          key: "city",
          align: "center",
        },
        {
          title: "是否同步",
          key: "isPlant",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      shareUrl: "", //二维码路径
      badgeType: "展商证",
      list: [],
      loading: false,
    };
  },
  components: {},
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  computed: {
    ...mapGetters({
      hostExhibitionId: "hostSetModule/getHostExhibitionId",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapActions({
      DeletePlan: "exhibitionModule/DeletePlan",
      getDeExCardUpPageList: "exhibitionModule/getDeExCardUpPageList",
    }),

    async init() {
        this.loading = true;
      let opt = {
        sorts: [{ propertyName: "inTime", ascending: false }],
        exhibitionId: this.exhibitionInfo.id,
        badgeType: this.badgeType,
        companyName: this.searchName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      };

       let Wheres = {
        Type: 0,
        Wheres: {
          WhereGroupOperator: 0,
          Predicates: [
            {
              type: 1,
              wheres: {
                WhereOperator: 0,
                Label: "isPlant",
                Value: this.isPlant == "" ? null : this.isPlant == "是" ? true : false,
              },
            },
          ],
        },
      };

      if (this.isPlant) {
        opt.Wheres = Wheres;
      }
      
      let result = await this.getDeExCardUpPageList(opt);
      if (result) {
        this.list = result.items;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
        this.loading = false;
      }
    },

    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    searchAct() {
      this.pageIndex = 1;
      this.init();
    },

    //删除名单
    async delItem(row) {
      console.log(row, "删除的数据信息");
      let opt = {
        Id: row.id,
        PlanId: row.id,
        JoinId: row.joinId,
        ExhibitionId: this.exhibitionInfo.id,
      };
      let data = await this.DeletePlan(opt);
      if (data.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.fail(data.msg);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.layout {
  min-width: 800px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
  /deep/ {
    .ivu-tabs-tab {
      font-size: 24px;
      font-weight: bold;
    }
  }
}
.header-tool-box {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.htb-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 150px;
  height: 80px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border: 2px dotted #d13119;
  color: #d13119;
  background: #ffe6e3;
  margin-left: 20px;
  cursor: pointer;
}
.qrcode {
  display: flex;
  align-items: center;
  #qrcodeShare {
    display: block;
    margin-right: 200px;
  }
  .tips {
    font-size: 24px;
  }
}
.statistics {
  margin: 30px 0;
  display: flex;

  &-child {
    margin-right: 10px;
  }
}
</style>
